/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Volume_DurationInputs */

const en_ui_volume_duration = /** @type {(inputs: Ui_Volume_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duration`)
};

const de_ui_volume_duration = /** @type {(inputs: Ui_Volume_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

/**
* | output |
* | --- |
* | "Duration" |
*
* @param {Ui_Volume_DurationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_volume_duration = /** @type {((inputs?: Ui_Volume_DurationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Volume_DurationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_volume_duration(inputs)
	return de_ui_volume_duration(inputs)
});